document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    let variants = [];
    try { variants = JSON.parse(form.dataset.variants || '[]'); } catch (error) { return; }
    const idInput = form.querySelector('#product-id');
    const panel = form.closest('.pdp-info, .product-info') || document;
    const price = panel.querySelector('#product-price');
    const buttonPrice = form.querySelector('#product-button-price');
    const button = form.querySelector('.add-to-cart');
    const formatMoney = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(cents / 100);
    const refresh = () => {
      const selected = [...form.querySelectorAll('input[type="radio"][data-option-index]:checked')].sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)).map((input) => input.value);
      const variant = variants.find((item) => item.options && item.options.every((value, index) => value === selected[index])) || variants[0];
      if (!variant) return;
      idInput.value = variant.id;
      const formatted = formatMoney(variant.price);
      if (price) price.textContent = formatted;
      if (buttonPrice) buttonPrice.textContent = formatted;
      if (button) button.disabled = !variant.available;
      const gallery = form.closest('[data-product-page]')?.querySelector('[data-pdp-gallery]');
      const galleryInput = form.querySelector('input:checked[data-pdp-gallery-images]');
      const galleryImage = gallery?.closest('.pdp-stage')?.querySelector('[data-pdp-stage-image]');
      if (gallery && galleryInput && galleryImage) {
        const sources = galleryInput.dataset.pdpGalleryImages.split('|').filter(Boolean);
        if (sources.length) {
          gallery.dataset.pdpGalleryImages = galleryInput.dataset.pdpGalleryImages;
          gallery.dataset.pdpGalleryIndex = '0';
          galleryImage.src = sources[0];
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      form.querySelectorAll('[data-option-index]').forEach((input) => input.closest('.option-value')?.classList.toggle('is-selected', input.checked));
      form.querySelectorAll('.product-option').forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        const label = fieldset.querySelector('.selected-option-value');
        if (checked && label) label.textContent = checked.value;
      });
    };
    form.addEventListener('change', refresh);
    refresh();
  });

  document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
    const stage = gallery.closest('.pdp-stage');
    const image = stage?.querySelector('[data-pdp-stage-image]');
    if (!image) return;
    let index = 0;
    const move = (amount) => {
      const sources = (gallery.dataset.pdpGalleryImages || '').split('|').filter(Boolean);
      if (sources.length < 2) return;
      index = Number(gallery.dataset.pdpGalleryIndex || index);
      index = (index + amount + sources.length) % sources.length;
      gallery.dataset.pdpGalleryIndex = String(index);
      image.src = sources[index];
    };
    gallery.querySelector('[data-pdp-gallery-prev]')?.addEventListener('click', () => move(-1));
    gallery.querySelector('[data-pdp-gallery-next]')?.addEventListener('click', () => move(1));
  });
});
